'use strict';

/**
 * MapStore
 */

var MapStore = function (Flux, MapActions, Utils, APP_DISPATCHER_ID) {
  var initialized = false,
      SiteStore = Flux.Store.get('SiteStore'),
      DataCaptureStore = Flux.Store.get('DataCaptureStore'),
      DispatcherUtil = Flux.Dispatcher,
      MapStore = Flux.Store.create({
        name: 'MapStore',
        events: {
          Changed: true,
          ActiveLayerChanged: true,
          DeleteActiveLayer: true,
          ClearDownload: true
        }
      });

  MapStore.init = function () {
    if (!initialized) {
      var d = Flux.Dispatcher.get(APP_DISPATCHER_ID);
      d.register(MapActions.SetActiveLayer, this.onSelectAnnotationLayer.bind(this));
      d.register(MapActions.DeleteActiveAnnotationLayer, this.onDeleteAnnotationLayer.bind(this));
      d.register(MapActions.ClearDownload, this.onClearDownload.bind(this));
      d.register(MapActions.SetOpacityValues, this.onSetOpacityValues.bind(this));

      initialized = true;
    }

    var AnnotationStore = Flux.Store.get('AnnotationStore');

    // Can't get a handle on $scope to pass in as 3rd argument.  Memory leak vector?
    SiteStore.on(SiteStore.Events.Changed, MapStore.handleSiteStoreChanged.bind(this));
    DataCaptureStore.on(DataCaptureStore.Events.Changed, MapStore.handleDataCaptureStoreChanged.bind(this));
    AnnotationStore.on(AnnotationStore.Events.Changed, MapStore.handleAnnotationStoreChanged.bind(this));
  };

  MapStore.onSelectAnnotationLayer = function(action) {
    MapStore.$set('activeAnnotationLayerId', action.layerId);
    MapStore.emit(MapStore.Events.ActiveLayerChanged, action.layerId);
  };

  MapStore.onDeleteAnnotationLayer = function(action) {
    MapStore.emit(MapStore.Events.DeleteActiveLayer);
  };

  MapStore.handleSiteStoreChanged = function handleSiteStoreChanged () {
    MapStore.$set('site', SiteStore.get('current'));
    MapStore.emit(MapStore.Events.Changed);
  };

  MapStore.handleDataCaptureStoreChanged = function handleDataCaptureStoreChanged () {
    MapStore.$set('dataCapture', DataCaptureStore.get('current'));
    MapStore.emit(MapStore.Events.Changed);
  };

  MapStore.handleAnnotationStoreChanged = function handleAnnotationStoreChanged () {
    var AnnotationStore = Flux.Store.get('AnnotationStore');
    MapStore.$set('annotations', AnnotationStore.get('current'));
    MapStore.emit(MapStore.Events.Changed);
  };

  MapStore.onClearDownload = function onClearDownload () {
    MapStore.emit(MapStore.Events.ClearDownload);
  };

  MapStore.onSetOpacityValues = function onSetOpacityValues (payload) {
    this.$set('dcOpacity', payload.opacities.dcOpacity);
    this.$set('mapOpacity', payload.opacities.mapOpacity);
  };

  // MapStore.watch('location', MapStore.Events.Changed, 'collection');

  return MapStore;
};

MapStore.$inject = ['sbFlux', 'MapActions', 'Utils', 'APP_DISPATCHER_ID'];
module.exports = MapStore;



// WEBPACK FOOTER //
// ./src/app/dash/map/MapStore.js